import { render, staticRenderFns } from "./ExplorePostCard.vue?vue&type=template&id=26eace6f&scoped=true"
import script from "./ExplorePostCard.vue?vue&type=script&lang=js"
export * from "./ExplorePostCard.vue?vue&type=script&lang=js"
import style0 from "./ExplorePostCard.vue?vue&type=style&index=0&id=26eace6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eace6f",
  null
  
)

export default component.exports